import { cx } from 'emotion';
import { useSelector } from 'react-redux';

import { localizedTableNameSelector } from '@ezugi/bootstrap/src/store/selectors';
import { GameFooter } from '@ezugi/ui/components/GameFooter/GameFooter';
import { DeviceInfo } from '@ezugi/utils/src/helpers/deviceInfo';

import useTableLimits from '../../hooks/useTableLimits';
import handheldTableLimitsClassName from './style.css';

const TableLimits = () => {
  const tableName = useSelector(localizedTableNameSelector);
  const tableLimits = useTableLimits();

  return (
    <GameFooter.Text
      label={tableName}
      value={tableLimits}
      className={cx({
        [handheldTableLimitsClassName]: DeviceInfo.isHandheld,
      })}
      data-e2e="footer-table-info"
    />
  );
};

export default TableLimits;
